import { useEffect, useState } from "react";
import { CONSENT_CHANGED_EVENT, NO_CONSENT, readConsent } from "./consent.js";

/**
 * The visitor's stored choice, for components inside the hydrated #root
 * tree.
 *
 * Deliberately starts at NO_CONSENT and only reads document.cookie in an
 * effect, never during render. The prerendered snapshot is produced with
 * no cookie at all, so a component that read the real value on its first
 * render would produce different markup for a returning visitor than the
 * snapshot hydration compares against — the exact mismatch the cookie
 * banner sits in its own React root to avoid. Rendering "not granted"
 * first and revealing after mount is one frame slower and always correct.
 */
export function useConsent() {
  const [consent, setConsent] = useState(NO_CONSENT);

  useEffect(() => {
    const read = () => setConsent(readConsent() ?? NO_CONSENT);
    read();
    window.addEventListener(CONSENT_CHANGED_EVENT, read);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, read);
  }, []);

  return consent;
}
